import React from 'react';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/vQgkaLFS6dqp6hkZ7pfxoA/Offical-SinclairDevelopment-logo.png';

/*
  The source file is a 1932×1932 square with wide black margins.
  These values crop it to the artwork itself (mark + wordmark),
  measured in source pixels.
*/
const SOURCE_SIZE = 1932;
const CROP = {
  x: 250,
  y: 480,
  width: 1460,
  height: 1030
};
const imgStyle: React.CSSProperties = {
  position: 'absolute',
  maxWidth: 'none',
  width: `${SOURCE_SIZE / CROP.width * 100}%`,
  left: `${-CROP.x / CROP.width * 100}%`,
  top: `${-CROP.y / CROP.height * 100}%`
};
interface LogoProps {
  /** Set the height with a Tailwind class (e.g. "h-14"); width follows the logo's proportions. */
  className?: string;
}
export function Logo({
  className = 'h-14'
}: LogoProps) {
  return <span className={`relative inline-block overflow-hidden align-middle bg-black ${className}`} data-id="element-161" data-mp="2yi5ef4nobfw5">
      {/* Invisible sizer: gives the box the cropped logo's exact proportions */}
      <svg viewBox={`0 0 ${CROP.width} ${CROP.height}`} className="block h-full w-auto" aria-hidden="true" data-id="element-162" data-mp="1eu83wcmx3n37" />
      <img src={LOGO_SRC} alt="Sinclair Development, Inc." style={imgStyle} data-id="element-163" data-mp="19xrfrifpx8q4" />
    </span>;
}